export default __webpack_public_path__ + "static/media/uploadFile.6c31612b.svg";